var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCareRecipientsRound = function SvgCareRecipientsRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "#FCFCFF",
    stroke: "#DDDFE5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#care-recipients-round_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#care-recipients-round_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B2A35",
    d: "M18 22.75c-2.34 0-7 1.17-7 3.5V28h14v-1.75c0-2.33-4.66-3.5-7-3.5ZM13.34 26c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25h-9.32ZM18 21c1.93 0 3.5-1.57 3.5-3.5S19.93 14 18 14s-3.5 1.57-3.5 3.5S16.07 21 18 21Zm0-5c.83 0 1.5.67 1.5 1.5S18.83 19 18 19s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5Zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V28h4v-1.75c0-2.02-3.5-3.17-5.96-3.44ZM24 21c1.93 0 3.5-1.57 3.5-3.5S25.93 14 24 14c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "care-recipients-round_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 9h24v24H9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "care-recipients-round_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 9h24v24H9z"
  })))));
};
export default SvgCareRecipientsRound;